import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import React, { useMemo } from "react";
import { AppRoutes } from "./routes";
import { Routes as AppRouteMetadata } from "../../routes/constants";
var RedirecionarDetalheRequerimento = function () {
    var id = useParams().id;
    return _jsx(Navigate, { to: "".concat(AppRouteMetadata.REQUERIMENTO_VISUALIZAR.path, "/").concat(id), replace: true });
};
export var RouterManager = function () {
    var routes = useMemo(function () {
        return Object.keys(AppRoutes).map(function (path) {
            var RouteComponent = AppRoutes[path];
            return _jsx(Route, { path: path, element: _jsx(RouteComponent, {}) }, path);
        });
    }, []);
    return (_jsxs(Routes, { children: [routes, _jsx(Route, { path: "/requerimento/meus-requerimentos", element: _jsx(Navigate, { to: "".concat(AppRouteMetadata.HOME.path), replace: true }) }), _jsx(Route, { path: "/requerimento/meus-requerimentos/:id", element: _jsx(RedirecionarDetalheRequerimento, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "".concat(AppRouteMetadata.HOME.path), replace: true }) })] }));
};
